import EditForm from './_form-edit'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    EditForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('pool.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.pool.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.pool.index'), route: {name: 'pool-index'}},
          {label: this.$t('breadcrumbs.pool.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updatePool(data) {
      API.pool.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('pool.edit.succesfullyUpdated'))
        this.$router.push({name: 'pool-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
